const isRoleForSign = (role) => {
    return role === 'OWNER' || role === 'STATE_OWNER' || role === 'STATE_ACCOUNTANT';
};

export default isRoleForSign;
